import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { hasCardFeature } from 'utils/facades/utils';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';
import { box } from '../box/recipe';
import { resultShape } from '../result-shape/recipe';
import { resultText } from '../result-text/recipe';

export const answer = (
	context: CreationContextFor<typeof COMPONENT_TYPE.ANSWER>
): CreatedBuildingBlock<typeof COMPONENT_TYPE.ANSWER> =>
	createModel({
		type: COMPONENT_TYPE.ANSWER,
		editorProps: {
			expandable: true,
		},
		componentProps: {
			[UNIFORM_PROPS.answerTimeout]: 0,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DESKTOP]: {},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.TABLET]: {},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {},
				},
				[COMPONENT_STATES.HOVER]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
				[COMPONENT_STATES.CORRECT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
				[COMPONENT_STATES.INCORRECT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
			},
			other: {},
		},
		children: hasCardFeature(context.cardType).results ? [resultText(), resultShape(), box()] : [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.ANSWER>;
